import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Problem = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-slate-900 text-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-amber-400">
          {t.problem.label}
        </span>
        <h2 className="text-3xl md:text-5xl font-bold mb-12 leading-tight">
          {t.problem.title}
        </h2>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12">
          {t.problem.situations.map((situation, index) => (
            <span
              key={index}
              className="px-5 py-3 rounded-full bg-white/5 border border-white/10 text-base md:text-lg font-medium text-slate-100 hover:bg-white/10 transition-colors duration-300"
            >
              {situation}
            </span>
          ))}
        </div>

        <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed">
          {t.problem.description}
        </p>
      </div>
    </section>
  );
};

export default Problem;
